var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Color-Painting-Palette--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Color Painting Palette Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.92 11.24a12.33 12.33 0 0 0 -9 -10.37 9.82 9.82 0 0 0 -5.78 0A12.47 12.47 0 0 0 0.36 9.75a11.88 11.88 0 0 0 3.16 11.38 2.5 2.5 0 0 0 3.08 0.36 1.5 1.5 0 0 0 0.26 -2.33l-0.81 -0.81a1 1 0 0 1 0 -1.42 1.1 1.1 0 0 1 1.6 -0.19c1.41 1.41 5.62 5.66 5.62 5.66a4 4 0 0 0 2.82 1.18 3.68 3.68 0 0 0 1.91 -0.53 12 12 0 0 0 5.92 -11.81Zm-9.44 7.62a2.49 2.49 0 0 1 0 -3.53 2.54 2.54 0 0 1 3.53 0 2.5 2.5 0 0 1 -3.53 3.53ZM14.25 7.2a2 2 0 0 1 2 -2 2 2 0 1 1 -2 2Zm3.69 6a1.5 1.5 0 0 1 2.12 -2.12 1.5 1.5 0 1 1 -2.12 2.12Zm-6.29 -8.48a2 2 0 1 1 -2.83 0 2 2 0 0 1 2.83 0Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArt);
export default ForwardRef;